module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'scheduler',
        'scheduler',
    ],

    config: {
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_status': true,
            'resourceChanged.bo_absence': true,
            'resourceChanged.bo_projects': true,
            'resourceChanged.bo_customers': false,
            'resourceChanged.bo_employees': false,
            'resourceChanged.bo_contractors': false,
            'resourceChanged.bo_projectTerms': true,
            'resourceChanged.bo_projectTermJobs': false,
            'resourceChanged.bo_customerContacts': false,
            'resourceChanged.bo_projectTermJobStatus': false
        },
    }
}